// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1ynB7","boxTitle":"Qualiphy_boxTitle__3A7ha","box":"Qualiphy_box__ny2Gy","toggleWrap":"Qualiphy_toggleWrap__27SYr"};